import React, { useRef, useState, useLayoutEffect } from 'react';
import { BottomSheet as BottomSheetComponent } from 'react-spring-bottom-sheet';
import 'react-spring-bottom-sheet/dist/style.css';
import './BottomSheet.css';

const BottomSheet = ({ header, content, onSetHeight }) => {
  const headerRef = useRef(null);
  const [headerHeight, setHeaderHeight] = useState(0);

  useLayoutEffect(() => {
    if (headerRef.current) {
      const measuredHeight = headerRef.current.offsetHeight + 28;
      const minHeaderHeight = 280;
      const finalHeight = Math.max(measuredHeight, minHeaderHeight);

      setHeaderHeight(finalHeight);
      if (onSetHeight) onSetHeight(finalHeight);
    }
  }, []);

  return (
    <>
      {/* Header oculto solo para medir */}
      <div ref={headerRef} style={{ visibility: 'hidden', position: 'absolute' }}>
        <div
          style={{
            padding: 16,
            paddingBottom: 10,
          }}
        >
          {header}
        </div>
      </div>

      {headerHeight > 0 && (
        <BottomSheetComponent
          open={true}
          blocking={false}
          snapPoints={({ maxHeight }) => [
            Math.max(headerHeight, maxHeight * 0.32),
            maxHeight - 55,
          ]}
          defaultSnap={({ maxHeight }) => [Math.max(headerHeight, maxHeight * 0.32)]}
          skipInitialTransition
          expandOnContentDrag
          animationConfig={{
            tension: 400,
            friction: 40,
          }}
        >
          <>
            <div>
              <div
                style={{
                  padding: 16,
                  paddingBottom: 10,
                }}
              >
                {header}
              </div>
            </div>
            <div className='sheet-content'>{content}</div>
          </>
        </BottomSheetComponent>
      )}
    </>
  );
};

export default BottomSheet;
